import { Component, Input } from '@angular/core';
import { Area } from '../../models/area'
import { ConversaAreaPage } from '../../pages/conversa-area/conversa-area';
import { NavController } from 'ionic-angular';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { BrComDao } from '../../service/BrComDao';
import { FotoProvider } from '../../providers/foto/foto';

@Component({
  selector: 'conversa-area',
  templateUrl: 'conversa-area.html'
})
export class ConversaAreaComponent extends AtalhoConversa {

  @Input() area: Area;
  private idUsuario: number;
  public isAdmin: boolean;

  constructor(private navCtrl: NavController, private brComDAO: BrComDao, private fotoProvider: FotoProvider) {
    super();
    this.idUsuario = this.brComDAO.getEmpresa().IdUsuario;
  }

  ngOnInit() {
    this.atualizarUltimaMensagem(this.area.mensagens);
    this.isAdmin = this.isUsuarioAdmin();
  }

  protected atualizarNumMensagensNaoLidas(): void {
    const mensagens = this.area.mensagens;
    if (mensagens) {
      //filtra todas as mensagens que foram enviadas ao usuário e não foram lidas
      this.quantidadeMensagensNaoLidas = mensagens.filter(m => m.origem === "L"
        && !m.statusMensagemLida).length;
    }
  }

  public abrirConversa(): void {
   /* this.navCtrl.push(ConversaAreaPage, {
      area: this.area
    })*/
  };

  public isUsuarioAdmin(): boolean {
    const idAdmins = this.area.idAdministradores || [];
    for (const idAdmin of idAdmins) {
      if (idAdmin === this.idUsuario) {
        return true;
      }
    }
    return false;
  }

  public getFotoPerfil(): string {
    if (this.area.hashImagem === "" || !this.area.hashImagem) {
      return "assets/img/usuario.png";
    }
    return this.fotoProvider.getUrlImagemServidor(this.area.hashImagem);
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-area/conversa-area.ts